export default __webpack_public_path__ + "static/media/Equipe1.5ef7cc2b.png";